import React, { PropsWithChildren, ReactNode } from "react";

import { Link } from "react-router-dom";
import {
  Flex,
  Stack,
  StackDivider,
  Box,
  Avatar,
  Image,
  Menu,
  MenuButton,
  MenuList,
  MenuGroup,
  MenuItem,
} from "@chakra-ui/react";

import Logo from "../../Logo";

import useStore from "../../../store";
import useTranslations from "../../../hooks/useTranslations";

const ViewerAvatarMenu = () => {
  const t = useTranslations();
  const viewer = useStore((state) => state.viewer);

  return (
    <Menu id={`${viewer.id}.navigation-menu`}>
      <MenuButton as="button">
        <Avatar src={viewer?.avatar || ""} name={viewer?.name} />
      </MenuButton>
      <MenuList zIndex="dropdown">
        <MenuGroup title={t("header.profile") as string}>
          <MenuItem as={Link} to="/profile">
            {t("userProfile.myProfile")}
          </MenuItem>
          <MenuItem as={Link} to="/profile">
            {t("header.logout")}
          </MenuItem>
        </MenuGroup>
      </MenuList>
    </Menu>
  );
};

export const NavigationHeader: React.FC<
  PropsWithChildren<{
    subHeader?: ReactNode;
    isBranded?: boolean;
    rightElement?: ReactNode;
  }>
> = ({ subHeader, isBranded = false, rightElement, children }) => {
  const viewer = useStore((state) => state.viewer);

  return (
    <Flex
      direction="column"
      position="sticky"
      zIndex="sticky"
      top={0}
      bgColor="white"
      boxShadow="sm"
    >
      <Box borderBottom="gray">
        <Box px={["4", "16", "20", "36"]}>
          <Flex justify="between" align="center" py="3" height="20">
            <Stack
              direction="row"
              spacing={"5"}
              flex={1}
              mr="auto"
              divider={<StackDivider display={["none", "block"]} />}
            >
              <Link to="/">
                <Logo width="90px" />
              </Link>
              {isBranded && viewer.company.visualIdentity && (
                <Image
                  display={["none", "block"]}
                  src={viewer.company.visualIdentity}
                  objectFit="cover"
                  h="33px"
                  alt={viewer.company.name}
                />
              )}
            </Stack>
            <Box flexShrink={0}>{children}</Box>
            <Stack
              spacing="6"
              flex={1}
              direction="row"
              ml="auto"
              justify="flex-end"
              alignItems="center"
            >
              {rightElement}
              <ViewerAvatarMenu />
            </Stack>
          </Flex>
        </Box>
      </Box>
      {subHeader}
    </Flex>
  );
};
